import RouteMeta from '@/types/RouteMeta'
import unitStore from '@/stores/unit.store'

const dsUnitRoutes = [
  {
    path:
      import.meta.env.VITE_MODE === 'local' ||
      window.location.href.includes(import.meta.env.VITE_B2C_BASE_URL as string)
        ? '/'
        : '/ds',
    name: 'ds',
    redirect: () => ({
      name: 'ds.home',
    }),
    component: () => import('./Index.vue'),
    meta: {
      unitRoute: true,
      navIcon: 'user',
    },
    children: [
      {
        path: 'home',
        name: 'ds.home',
        component: () => import('./views/DsHome.vue'),
        meta: {
          title: 'Home',
          icon: 'home',
          topNav: false,
        } as RouteMeta,
      },
      {
        path: 'study-match',
        redirect: () => ({
          name: 'ds.tips',
        }),
        meta: {},
      },
      {
        path: 'application/search/5/:jobOpeningId/details',
        redirect: () => ({
          name: 'ds.application.selfmatching.details',
        }),
        meta: {},
      },
      {
        path: 'application/selfmatching/1',
        redirect: () => ({
          name: 'ds.application.selfmatching.overview',
        }),
        meta: {},
      },
      {
        path: 'selfmatching',
        name: 'ds.application.selfmatching',
        redirect: () => ({
          name: 'ds.application.selfmatching.overview',
        }),
        component: () =>
          import('./views/applications/selfmatching/Selfmatching.vue'),
        meta: {
          color: 'blue',
          topNav: false,
          title: 'Praxispartner-Vorschläge',
          icon: 'sign',
          step: 2,
        } as RouteMeta,
        children: [
          {
            path: '',
            name: 'ds.application.selfmatching.overview',
            component: () =>
              import(
                './views/applications/selfmatching/Selfmatching_Overview.vue'
              ),
          },
          {
            path: ':jobOpeningId',
            name: 'ds.application.selfmatching.details',
            component: () =>
              import(
                './views/applications/selfmatching/Selfmatching_Details.vue'
              ),
          },
        ],
      },
      {
        path: 'application/contracts',
        name: 'ds.application.contracts',
        component: () => import('./views/applications/contracts/Contracts.vue'),
        meta: {
          color: 'green',
          topNav: false,
          title: 'Einschreibung',
          icon: 'sign',
          step: 3,
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.application.contracts.personal',
            component: () =>
              import('./views/applications/contracts/Step1_Personal.vue'),
          },
          {
            path: '2',
            name: 'ds.application.contracts.documents',
            component: () =>
              import('./views/applications/contracts/Step2_Documents.vue'),
          },
        ],
      },
      {
        path: 'profile',
        name: 'ds.profile',
        redirect: () => ({
          name: 'ds.profile.contact',
        }),
        component: () => import('./views/profile/Profile.vue'),
        meta: {
          color: 'orange',
          topNav: true,
          title: 'Profileinstellungen',
          icon: 'user',
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.profile.contact',
            component: () => import('./views/profile/Step1_Contact.vue'),
          },
          {
            path: '2',
            name: 'ds.profile.partner',
            component: () => import('./views/profile/Step2_Partner.vue'),
          },
          {
            path: '3',
            name: 'ds.profile.notifications',
            component: () => import('./views/profile/Step3_Notifications.vue'),
          },
        ],
      },
      {
        path: 'contact',
        name: 'ds.contact',
        redirect: () => ({
          name: 'ds.contact.advisor',
        }),
        component: () => import('./views/contact/Contact.vue'),
        meta: {
          title: 'Kontakt',
          icon: 'envelope',
          color: 'orange',
          topNav: true,
        } as RouteMeta,
        children: [
          {
            path: '1',
            name: 'ds.contact.advisor',
            component: () => import('./views/contact/Step1_Advisor.vue'),
          },
          {
            path: '2',
            name: 'ds.contact.team',
            component: () => import('./views/contact/Step2_Team.vue'),
          },
          {
            path: '3',
            name: 'ds.contact.support',
            component: () => import('./views/contact/Step3_Support.vue'),
          },
        ],
      },
      {
        path: 'iutraining',
        name: 'ds.iutraining',
        component: () => import('./views/IuTrainingView.vue'),
        beforeEnter: () => {
          if (!unitStore.stageMinimumReady()) {
            return { name: 'ds.home' }
          }
        },
        meta: {
          title: 'IU Bewerbungstraining',
          icon: 'study-owl',
          navItem: true,
          topNav: true,
          topDivider: true,
          requiresStageMinimumReady: true,
        } as RouteMeta,
      },
      {
        path: 'tips',
        name: 'ds.tips',
        component: () => import('./views/TipsView.vue'),
        meta: {
          title: 'Tipps & Vorlagen',
          icon: 'checklist',
          navItem: true,
          topNav: true,
        } as RouteMeta,
      },
      {
        path: 'faq',
        name: 'ds.faq',
        component: () => import('./views/FaqView.vue'),
        meta: {
          title: 'Häufig gestellte Fragen',
          icon: 'question-circle',
          navItem: true,
          topNav: true,
          wizardExcluded: true,
        } as RouteMeta,
      },
      {
        path: 'cvgenerator',
        name: 'ds.cvgenerator',
        component: () => import('./views/CvGeneratorView.vue'),
        meta: {
          title: 'Profil Generator',
          icon: 'question-circle',
        } as RouteMeta,
      },
      {
        path: 'bringafriend',
        name: 'ds.baf',
        component: () => import('./views/BringAFriendView.vue'),
        meta: {
          title: 'Freunde werben',
          icon: 'checklist',
        } as RouteMeta,
      },
      {
        path: 'documents-builder',
        component: () =>
          import('./views/documents-builder/DocsBuilderLayout.vue'),
        meta: {
          title: 'Bewerbungsunterlagen',
          icon: 'checklist',
        } as RouteMeta,
        children: [
          {
            path: '',
            name: 'ds.documents-builder',
            component: () => import('./views/documents-builder/Index.vue'),
          },
          {
            path: 'preview',
            name: 'ds.documents-builder.preview',
            component: () =>
              import('./views/documents-builder/PreviewView.vue'),
            meta: {
              title: 'Vorschau',
            } as RouteMeta,
          },
          {
            path: 'personal-data',
            name: 'ds.documents-builder.personal-data',
            component: () => import('./forms/PersonalDataForm.vue'),
            meta: {
              title: 'Persönliche Daten',
            } as RouteMeta,
          },
          {
            path: 'education',
            name: 'ds.documents-builder.education',
            component: () =>
              import('./views/documents-builder/EducationListView.vue'),
            meta: {
              title: 'Bildungsweg',
            } as RouteMeta,
          },
          {
            path: 'education/new',
            name: 'ds.documents-builder.education.new',
            component: () => import('./forms/EducationForm.vue'),
            meta: {
              title: 'Bildungsweg',
              documentsBuilderBackRoute: 'ds.documents-builder.education',
            } as RouteMeta,
          },
          {
            path: 'education/:entryUuid',
            name: 'ds.documents-builder.education.edit',
            component: () => import('./forms/EducationForm.vue'),
            props: true,
            meta: {
              title: 'Bildungsweg',
              documentsBuilderBackRoute: 'ds.documents-builder.education',
            } as RouteMeta,
          },
          {
            path: 'work-experience',
            name: 'ds.documents-builder.work-experience',
            component: () =>
              import('./views/documents-builder/WorkExperienceListView.vue'),
            meta: {
              title: 'Berufserfahrung, Praktika & Nebenjobs',
            } as RouteMeta,
          },
          {
            path: 'work-experience/new',
            name: 'ds.documents-builder.work-experience.new',
            component: () => import('./forms/WorkExperienceForm.vue'),
            meta: {
              title: 'Berufserfahrung',
              documentsBuilderBackRoute: 'ds.documents-builder.work-experience',
            } as RouteMeta,
          },
          {
            path: 'work-experience/:experienceUuid',
            name: 'ds.documents-builder.work-experience.edit',
            component: () => import('./forms/WorkExperienceForm.vue'),
            props: true,
            meta: {
              title: 'Berufserfahrung',
              documentsBuilderBackRoute: 'ds.documents-builder.work-experience',
            } as RouteMeta,
          },
          {
            path: 'motivation',
            name: 'ds.documents-builder.motivation',
            component: () => import('./forms/MotivationForm.vue'),
            meta: {
              title: 'Motivationsschreiben',
              documentsBuilderStepProgress: {
                currentStepIndex: 0,
                totalSteps: 3,
              },
            } as RouteMeta,
          },
          {
            path: 'motivation/experience',
            name: 'ds.documents-builder.motivation.experience',
            component: () => import('./forms/MotivationForm.vue'),
            props: { step: 2 },
            meta: {
              title: 'Motivationsschreiben',
              documentsBuilderBackRoute: 'ds.documents-builder.motivation',
              documentsBuilderStepProgress: {
                currentStepIndex: 1,
                totalSteps: 3,
              },
            } as RouteMeta,
          },
          {
            path: 'motivation/personality',
            name: 'ds.documents-builder.motivation.personality',
            component: () => import('./forms/MotivationForm.vue'),
            props: { step: 3 },
            meta: {
              title: 'Motivationsschreiben',
              documentsBuilderBackRoute:
                'ds.documents-builder.motivation.experience',
              documentsBuilderStepProgress: {
                currentStepIndex: 2,
                totalSteps: 3,
              },
            } as RouteMeta,
          },
          {
            path: 'photo',
            name: 'ds.documents-builder.photo',
            component: () => import('./forms/PhotoUploadForm.vue'),
            meta: {
              title: 'Bewerbungsfoto',
            } as RouteMeta,
          },
          {
            path: 'certificate',
            name: 'ds.documents-builder.certificate',
            component: () => import('./forms/CertificateUploadForm.vue'),
            meta: {
              title: 'Zeugnis hochladen',
            } as RouteMeta,
          },
          {
            path: 'mobility',
            name: 'ds.documents-builder.mobility',
            component: () => import('./forms/MobilityForm.vue'),
            meta: {
              title: 'Mobilität',
              documentsBuilderStepProgress: {
                currentStepIndex: 0,
                totalSteps: 2,
              },
            } as RouteMeta,
          },
          {
            path: 'mobility/car',
            name: 'ds.documents-builder.mobility.car',
            component: () => import('./forms/MobilityForm.vue'),
            props: { step: 2 },
            meta: {
              title: 'Mobilität',
              documentsBuilderBackRoute: 'ds.documents-builder.mobility',
              documentsBuilderStepProgress: {
                currentStepIndex: 1,
                totalSteps: 2,
              },
            } as RouteMeta,
          },
          {
            path: 'languages',
            name: 'ds.documents-builder.languages',
            component: () =>
              import('./views/documents-builder/LanguagesListView.vue'),
            meta: {
              title: 'Sprachen',
            } as RouteMeta,
          },
          {
            path: 'languages/new',
            name: 'ds.documents-builder.languages.new',
            component: () => import('./forms/LanguagePickerForm.vue'),
            meta: {
              title: 'Sprachen',
              documentsBuilderBackRoute: 'ds.documents-builder.languages',
            } as RouteMeta,
          },
          {
            path: 'languages/new/:languageCode',
            name: 'ds.documents-builder.languages.new.level',
            component: () => import('./forms/LanguageLevelForm.vue'),
            props: true,
            meta: {
              title: 'Sprachen',
              documentsBuilderBackRoute: 'ds.documents-builder.languages.new',
            } as RouteMeta,
          },
          {
            path: 'languages/:languageCode',
            name: 'ds.documents-builder.languages.edit',
            component: () => import('./forms/LanguageLevelForm.vue'),
            props: true,
            meta: {
              title: 'Sprachen',
              documentsBuilderBackRoute: 'ds.documents-builder.languages',
            } as RouteMeta,
          },
          {
            path: 'hard-skills',
            name: 'ds.documents-builder.hard-skills',
            component: () =>
              import('./views/documents-builder/HardSkillsListView.vue'),
            meta: {
              title: 'Kenntnisse',
            } as RouteMeta,
          },
          {
            path: 'hard-skills/new',
            name: 'ds.documents-builder.hard-skills.new',
            component: () => import('./forms/HardSkillsForm.vue'),
            meta: {
              title: 'Kenntnisse',
              documentsBuilderBackRoute: 'ds.documents-builder.hard-skills',
            } as RouteMeta,
          },
          {
            path: 'hard-skills/:skillIndex',
            name: 'ds.documents-builder.hard-skills.edit',
            component: () => import('./forms/HardSkillsForm.vue'),
            props: true,
            meta: {
              title: 'Kenntnisse',
              documentsBuilderBackRoute: 'ds.documents-builder.hard-skills',
            } as RouteMeta,
          },
          {
            path: 'soft-skills',
            name: 'ds.documents-builder.soft-skills',
            component: () =>
              import('./views/documents-builder/SoftSkillsListView.vue'),
            meta: {
              title: 'Soft Skills',
            } as RouteMeta,
          },
          {
            path: 'soft-skills/new',
            name: 'ds.documents-builder.soft-skills.new',
            component: () => import('./forms/SoftSkillsForm.vue'),
            meta: {
              title: 'Soft Skills',
              documentsBuilderBackRoute: 'ds.documents-builder.soft-skills',
            } as RouteMeta,
          },
          {
            path: 'soft-skills/:skillUuid',
            name: 'ds.documents-builder.soft-skills.edit',
            component: () => import('./forms/SoftSkillsForm.vue'),
            props: true,
            meta: {
              title: 'Soft Skills',
              documentsBuilderBackRoute: 'ds.documents-builder.soft-skills',
            } as RouteMeta,
          },
          {
            path: 'hobbies',
            name: 'ds.documents-builder.hobbies',
            component: () =>
              import('./views/documents-builder/HobbiesListView.vue'),
            meta: {
              title: 'Hobbys',
            } as RouteMeta,
          },
          {
            path: 'hobbies/new',
            name: 'ds.documents-builder.hobbies.new',
            component: () => import('./forms/HobbiesForm.vue'),
            meta: {
              title: 'Hobbys',
              documentsBuilderBackRoute: 'ds.documents-builder.hobbies',
            } as RouteMeta,
          },
          {
            path: 'hobbies/:hobbyUuid',
            name: 'ds.documents-builder.hobbies.edit',
            component: () => import('./forms/HobbiesForm.vue'),
            props: true,
            meta: {
              title: 'Hobbys',
              documentsBuilderBackRoute: 'ds.documents-builder.hobbies',
            } as RouteMeta,
          },
        ],
      },
    ],
  },
]

export default dsUnitRoutes
